// extracted by mini-css-extract-plugin
export default {"modal":"ImageEditorModal_modal__+nUh1"};